import * as angular from 'angular';

import { MixableBaseController } from '../../common/component';
import { VizTypes } from '../../common/types';

class VizPlaceholderController extends MixableBaseController {
  vizTitle: string;
  vizType: VizTypes;
  chartType: string;
  icon: string;
  isLoading: boolean;

  $onInit() {
    if (!this.chartType) {
      this.chartType = 'undefined';
    }
    const chartTest = this.chartType === 'undefined' ? this.vizType : this.chartType;

    switch (chartTest) {
      case 'table':
      case 'pivotTable':
        this.icon = 'ph-table';
        break;
      case 'python':
        this.icon = 'ph-notebook';
        break;
      case 'bigNumber':
      case 'bigValue':
        this.icon = 'ph-big-number';
        break;
      case 'bar':
        this.icon = 'ph-bar-grouped';
        break;
      case 'stackedBar':
        this.icon = 'ph-bar';
        break;
      case 'stackedBar100':
        this.icon = 'ph-bar-100';
        break;
      case 'hBar':
        this.icon = 'ph-bar-h-grouped';
        break;
      case 'hStackedBar':
        this.icon = 'ph-bar-h';
        break;
      case 'hStackedBar100':
        this.icon = 'ph-bar-h-100';
        break;
      case 'pie':
        this.icon = 'ph-pie';
        break;
      case 'donut':
        this.icon = 'ph-donut';
        break;
      case 'area':
        this.icon = 'ph-area';
        break;
      case 'totalArea':
        this.icon = 'ph-area-100';
        break;
      case 'line':
        this.icon = 'ph-line';
        break;
      case 'linePlusBar':
        this.icon = 'ph-line-bar';
        break;
      case 'scatter':
        this.icon = 'ph-scatter';
        break;
      default:
        // this is the most generic icon in case some scenario is unaccounted for
        this.icon = 'ph-notebook';
        break;
    }
  }
}
export const VizPlaceholderComponent: angular.IComponentOptions = {
  bindings: {
    vizTitle: '<',
    vizType: '<',
    chartType: '<',
    isLoading: '<',
  },
  template: `
  <div class="mode-placeholder editor-chart" ng-class="['viz-type-'+ctrl.vizType, 'chart-type-'+ctrl.chartType, {'loading':ctrl.isLoading}]">
    <div class="placeholder-content">
      <h4 class="placeholder-title">{{ ctrl.vizTitle }}</h4>
      <div class="placeholder-image">
        <svg-icon ng-if="ctrl.icon" type="ctrl.icon"></svg-icon>
      </div>
      <p class="loading-message">Fetching your data<span class="loading-dots"><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span></p>
    </div>
  </div>
  `,
  controller: VizPlaceholderController,
  controllerAs: 'ctrl',
};
